import { tv } from "tailwind-variants";

const FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS = {
  likely_not_a_problem_area: "likely_not_a_problem_area",
  likely_a_problem_area: "likely_a_problem_area",
  risk_of_underreporting_of_potential_problems:
    "risk_of_underreporting_of_potential_problems",
  risk_of_overreporting_of_potential_problems:
    "risk_of_overreporting_of_potential_problems",
  incongruent_reporting: "incongruent_reporting",
  limited_reporting: "limited_reporting",
} as const;

export type FunctionalDomainsInfoModalKeysType =
  keyof typeof FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS;

export const FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS_OPTIONS = Object.values(
  FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS,
);

export const domainTextStyle = tv({
  base: "font-semibold",
  variants: {
    status: {
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.likely_not_a_problem_area]:
        "text-complementary-success-800",
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.likely_a_problem_area]:
        "text-complementary-error-700",
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.risk_of_underreporting_of_potential_problems]:
        "text-complementary-warning-600",
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.risk_of_overreporting_of_potential_problems]:
        "text-complementary-warning-600",
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.incongruent_reporting]:
        "text-complementary-warning-600",
      [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.limited_reporting]:
        "text-complementary-warning-600",
    },
  },
});

export const getFunctionalDomainsInfoModalText = (
  key: FunctionalDomainsInfoModalKeysType,
) => {
  const text = {
    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.likely_not_a_problem_area]:
      "The person appears to be functioning well in  this domain, with no significant concerns observed.",
    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.likely_a_problem_area]:
      "The person shows signs of difficulty in this domain and could benefit from further evaluation.",
    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.risk_of_underreporting_of_potential_problems]:
      "The person might be underreporting in this domain. Further assessment may be needed to validate responses.",
    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.risk_of_overreporting_of_potential_problems]:
      "The person might be overstating concerns in this domain. Further assessment may help clarify the true level of difficulty.",
    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.incongruent_reporting]:
      "Inconsistencies in responses may reflect limited awareness or internal conflict. Identifying these patterns can offer valuable insight into sources of distress and help shape more targeted care.",

    [FUNCTIONAL_DOMAINS_INFO_MODAL_KEYS.limited_reporting]:
      "Limited information available on this domain. Further assessment may help clarify this domain.",
  };

  return text[key];
};
